import React, { Component } from 'react';
import '../myutils';
import {
  translate,
} from 'react-admin';
import BookIcon from '@material-ui/icons/Book';
import {IconButton} from '@material-ui/core';
import CallEnd from '@material-ui/icons/CallEnd';
import { configAPI } from '../config'

export const TemplateIcon = BookIcon;

class HangUpButton extends Component {

  state = {
    open: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      record: false
    }
  }

  hangup(id){
    const ReqGetSession = new Request(configAPI.api.prod + 'CallAction?ids='+id+'&action=hangup&token=' + sessionStorage.B.encodeDecode());
    fetch(ReqGetSession)
        .then(response => response.json())
        .then(session => {
          console.log(session);
        })
  }

  render() {
    return (
      <div style={{ float: "right" }}>
        <IconButton onClick={(e) => {this.hangup(this.props.call.id)}}>
          <CallEnd></CallEnd>
        </IconButton>
      </div>
    );
  }
}

export default translate(HangUpButton);
